import * as React from 'react'
import { FC, ComponentPropsWithRef } from 'react'
import * as style from './index.module.css'

interface Props {
  /** button type */
  readonly type: 'whiteTextEntry' | 'blackTextContact' | 'orangeTextEntry'
  /** button onClick */
  readonly onClick: () => void
}

/**
 * @file CtaButton
 */
export const CtaButton = ({ type, onClick }: Props): React.JSX.Element => {
  const typeObject = {
    orangeTextEntry: {
      className: style.orangeTextEntry,
      text: 'ENTRY',
      ariaLabel: 'エントリー',
    },
    blackTextContact: {
      className: style.blackTextContact,
      text: 'CONTACT',
      ariaLabel: 'コンタクト',
    },
    whiteTextEntry: {
      className: style.whiteTextEntry,
      text: 'ENTRY',
      ariaLabel: 'エントリー',
    },
  } as const

  const { className, text, ariaLabel } = typeObject[type]

  return (
    <button
      className={`${style.text} ${className}`}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      {text}
    </button>
  )
}
